'use client';

import React from 'react';
import styled from 'styled-components';
import { useDensity } from '@liftango/ui-tokens';

export interface TimeInputProps {
  value: string;
  onChange: (value: string) => void;
  min?: string;
  max?: string;
  step?: number;
  disabled?: boolean;
  'aria-label'?: string;
  className?: string;
}

const Input = styled.input<{ $height: number }>`
  height: ${(p) => p.$height}px;
  padding: 0 ${(p) => p.theme.spaceAlias.sm};
  border: 1px solid ${(p) => p.theme.colors.neutral.line};
  border-radius: ${(p) => p.theme.radius.md};
  background: ${(p) => p.theme.colors.neutral.panel};
  font-family: ${(p) => p.theme.fontFamily.mono};
  font-size: ${(p) => p.theme.fontSize.body};
  font-weight: ${(p) => p.theme.fontWeight.semibold};
  color: ${(p) => p.theme.colors.neutral.ink};
  &:focus {
    border-color: ${(p) => p.theme.colors.brand.primary};
    outline: ${(p) => p.theme.focus.width} solid ${(p) => p.theme.colors.brand.primary};
    outline-offset: ${(p) => p.theme.focus.insetOffset};
  }
  &:disabled {
    opacity: 0.5;
  }
`;

export const TimeInput = React.forwardRef<HTMLInputElement, TimeInputProps>(function TimeInput(
  { value, onChange, min, max, step, disabled, 'aria-label': ariaLabel, className },
  ref,
) {
  const density = useDensity();
  return (
    <Input
      ref={ref}
      type="time"
      $height={density.controlHeight}
      value={value}
      onChange={(e) => onChange(e.target.value)}
      min={min}
      max={max}
      step={step}
      disabled={disabled}
      aria-label={ariaLabel}
      className={className}
    />
  );
});
